<script setup lang="ts">
import { inject, onMounted, ref } from 'vue'

import debounce from 'lodash.debounce'

defineProps({
  showStoreList: {
    type: Boolean,
    required: true,
  },
})

const isMobile = ref<boolean>(false)

const checkWindow = debounce(() => {
  const width = window.innerWidth

  if (width <= 640) {
    isMobile.value = true
  }
  if (width > 640) {
    isMobile.value = false
  }
}, 200)

onMounted(() => {
  checkWindow()
  window.addEventListener('resize', checkWindow)
})

const emit = defineEmits<(e: 'shouldShow', show: boolean) => void>()
const brand = inject('BRAND')
</script>

<template>
  <div
    v-if="isMobile"
    class="flex gap-4 px-4 pt-1"
  >
    <button
      class="w-1/2 px-4 py-1"
      :class="{
        'border-b-4 pt-2': !showStoreList,
        'border-primary text-black': brand === 'ergobag',
        'border-primary text-primary': brand === 'ergobag' && !showStoreList,
        'border-black text-black': brand !== 'ergobag',
      }"
      aria-label="Show Map"
      @click="() => emit('shouldShow', false)"
    >
      {{ $t('map') }}
    </button>
    <button
      class="w-1/2 px-4 py-1"
      :class="{
        'border-b-4 pt-2': showStoreList,
        'border-primary text-black': brand === 'ergobag',
        'border-primary text-primary': brand === 'ergobag' && showStoreList,
        'border-black text-black': brand !== 'satch',
      }"
      aria-label="Show stores list"
      @click="() => emit('shouldShow', true)"
    >
      {{ $t('shopTitle') }}
    </button>
  </div>
</template>
